/* ============================================================
 * nv-pdp-conteudo.js - nova pagina de produto
 * - abas dos itens do kit
 * - "Ler mais" da descricao
 * - selo Ultimas unidades acompanha a variante escolhida
 * - avaliacoes: faixa de fotos e videos + avaliacoes com midia primeiro
 * - Converse conosco: atalhos para perguntar e ver perguntas e respostas
 * - nota do produto (abaixo do titulo) leva ate as avaliacoes
 * ============================================================ */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function go(el) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.scrollY - 100;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  /* ---------- abas do kit ---------- */
  function tabs(root) {
    var btns = $$('[role="tab"]', root);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) {
          var on = x === b;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          var p = document.getElementById(x.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
      });
    });
  }

  /* ---------- ler mais ---------- */
  function clamp(box) {
    var btn = box.parentNode.querySelector('[data-nv-clamp-btn]');
    if (!btn) return;
    function check() {
      if (box.classList.contains('nv-open')) return;
      var longo = box.scrollHeight > box.clientHeight + 8;
      btn.hidden = !longo;
      box.classList.toggle('nv-short', !longo);
    }
    btn.addEventListener('click', function () {
      var o = box.classList.toggle('nv-open');
      btn.textContent = o ? 'Ler menos' : 'Ler mais';
    });
    check();
    window.addEventListener('load', check);
    window.addEventListener('nv-clamp', function () { setTimeout(check, 30); });
  }

  /* ---------- filtros de Tudo sobre: mostra so o card escolhido ---------- */
  function filtros(nav) {
    var info = nav.closest('.nv-pdp-info');
    var links = $$('a', nav);
    var cards = links.map(function (a) { return document.getElementById((a.getAttribute('href') || '').slice(1)); });
    if (!info || !links.length) return;
    info.classList.add('nv-filtros-on');
    nav.setAttribute('role', 'tablist');
    function sel(i) {
      links.forEach(function (a, j) {
        a.classList.toggle('nv-on', j === i);
        a.setAttribute('aria-selected', j === i ? 'true' : 'false');
      });
      cards.forEach(function (c, j) {
        if (!c) return;
        c.classList.toggle('nv-show', j === i);
        if (j === i && c.tagName === 'DETAILS') c.open = true;
      });
      try { window.dispatchEvent(new Event('nv-clamp')); } catch (e) {}
    }
    links.forEach(function (a, i) {
      a.setAttribute('role', 'tab');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        sel(i);
        if (a.scrollIntoView && window.matchMedia('(max-width: 1024px)').matches) a.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
    });
    sel(0);
  }

  /* ---------- galeria grande (desktop): imagem maior, miniaturas, fechar e baixar ---------- */
  function semTamanho(u) {
    if (u.indexOf('blob:') === 0 || u.indexOf('data:') === 0) return u;
    try {
      var x = new URL(u, window.location.href);
      x.searchParams.delete('width'); x.searchParams.delete('height'); x.searchParams.delete('crop');
      return x.toString();
    } catch (e) { return u; }
  }
  function comLargura(u, w) {
    if (u.indexOf('blob:') === 0 || u.indexOf('data:') === 0) return u;
    try { var x = new URL(u, window.location.href); x.searchParams.set('width', w); return x.toString(); } catch (e) { return u; }
  }
  function baixar(url, nome) {
    return fetch(url, { mode: 'cors' }).then(function (r) { if (!r.ok) throw new Error('dl'); return r.blob(); }).then(function (b) {
      var a = document.createElement('a');
      a.href = URL.createObjectURL(b);
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      setTimeout(function () { URL.revokeObjectURL(a.href); a.parentNode.removeChild(a); }, 1500);
    }).catch(function () { window.open(url, '_blank', 'noopener'); });
  }
  /* foto montada do kit: redesenha a composicao (mesmas posicoes da galeria) em alta, com fundo transparente */
  function carregaCors(src) {
    return new Promise(function (res) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); };
      im.onerror = function () { res(null); };
      im.src = src;
    });
  }
  function kitImagem(frame, lado) {
    var box = frame.getBoundingClientRect();
    var itens = $$('img.nv-kit-item', frame);
    if (!itens.length || !box.width || !window.Promise) return Promise.resolve(null);
    var fx = lado / box.width, fy = lado / box.height;
    /* posicoes lidas agora, antes de qualquer mudanca de layout */
    var pos = itens.map(function (im) {
      var r = im.getBoundingClientRect();
      return { x: (r.left - box.left) * fx, y: (r.top - box.top) * fy, w: r.width * fx, h: r.height * fy, fill: window.getComputedStyle(im).objectFit === 'fill' };
    });
    return Promise.all(itens.map(function (im) { return carregaCors(comLargura(semTamanho(im.currentSrc || im.src), 1400)); })).then(function (fontes) {
      var c = document.createElement('canvas');
      c.width = lado; c.height = lado;
      var ctx = c.getContext('2d');
      ctx.imageSmoothingQuality = 'high';
      /* fundo branco + multiplicar: o fundo branco de cada foto some e um produto nao cobre o outro */
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, lado, lado);
      ctx.globalCompositeOperation = 'multiply';
      fontes.forEach(function (f, i) {
        if (!f) return;
        var p = pos[i];
        if (p.fill) { ctx.drawImage(f, p.x, p.y, p.w, p.h); return; }
        var s = Math.min(p.w / f.naturalWidth, p.h / f.naturalHeight);
        var dw = f.naturalWidth * s, dh = f.naturalHeight * s;
        ctx.drawImage(f, p.x + (p.w - dw) / 2, p.y + (p.h - dh), dw, dh);
      });
      return new Promise(function (res) {
        try { c.toBlob(function (b) { res(b ? URL.createObjectURL(b) : null); }, 'image/png'); } catch (e) { res(null); }
      });
    });
  }

  /* zip sem compressao (as fotos ja sao comprimidas), sem biblioteca externa */
  var CRC_T = null;
  function crc32(u8) {
    if (!CRC_T) {
      CRC_T = new Uint32Array(256);
      for (var n = 0; n < 256; n++) { var c = n; for (var k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1; CRC_T[n] = c >>> 0; }
    }
    var crc = 0xFFFFFFFF;
    for (var i = 0; i < u8.length; i++) crc = CRC_T[(crc ^ u8[i]) & 0xFF] ^ (crc >>> 8);
    return (crc ^ 0xFFFFFFFF) >>> 0;
  }
  function montaZip(arquivos) {
    var enc = new TextEncoder();
    var partes = [], central = [], offset = 0;
    var d = new Date();
    var hora = (d.getHours() << 11) | (d.getMinutes() << 5) | (d.getSeconds() >> 1);
    var data = ((d.getFullYear() - 1980) << 9) | ((d.getMonth() + 1) << 5) | d.getDate();
    arquivos.forEach(function (a) {
      var nome = enc.encode(a.nome), dados = a.dados, crc = crc32(dados);
      var lh = new DataView(new ArrayBuffer(30));
      lh.setUint32(0, 0x04034b50, true); lh.setUint16(4, 20, true); lh.setUint16(6, 0x0800, true); lh.setUint16(8, 0, true);
      lh.setUint16(10, hora, true); lh.setUint16(12, data, true); lh.setUint32(14, crc, true);
      lh.setUint32(18, dados.length, true); lh.setUint32(22, dados.length, true); lh.setUint16(26, nome.length, true); lh.setUint16(28, 0, true);
      partes.push(new Uint8Array(lh.buffer), nome, dados);
      var ch = new DataView(new ArrayBuffer(46));
      ch.setUint32(0, 0x02014b50, true); ch.setUint16(4, 20, true); ch.setUint16(6, 20, true); ch.setUint16(8, 0x0800, true); ch.setUint16(10, 0, true);
      ch.setUint16(12, hora, true); ch.setUint16(14, data, true); ch.setUint32(16, crc, true);
      ch.setUint32(20, dados.length, true); ch.setUint32(24, dados.length, true); ch.setUint16(28, nome.length, true);
      ch.setUint16(30, 0, true); ch.setUint16(32, 0, true); ch.setUint16(34, 0, true); ch.setUint16(36, 0, true); ch.setUint32(38, 0, true); ch.setUint32(42, offset, true);
      central.push(new Uint8Array(ch.buffer), nome);
      offset += 30 + nome.length + dados.length;
    });
    var tamCentral = central.reduce(function (s, p) { return s + p.length; }, 0);
    var fim = new DataView(new ArrayBuffer(22));
    fim.setUint32(0, 0x06054b50, true); fim.setUint16(8, arquivos.length, true); fim.setUint16(10, arquivos.length, true);
    fim.setUint32(12, tamCentral, true); fim.setUint32(16, offset, true);
    return new Blob(partes.concat(central, [new Uint8Array(fim.buffer)]), { type: 'application/zip' });
  }
  function baixarZip(urls, nomes, nomeZip) {
    return Promise.all(urls.map(function (u) {
      return fetch(u, { mode: 'cors' }).then(function (r) { if (!r.ok) throw new Error('dl'); return r.arrayBuffer(); });
    })).then(function (bufs) {
      var blob = montaZip(bufs.map(function (b, i) { return { nome: nomes[i], dados: new Uint8Array(b) }; }));
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = nomeZip;
      document.body.appendChild(a);
      a.click();
      setTimeout(function () { URL.revokeObjectURL(a.href); a.parentNode.removeChild(a); }, 2000);
    });
  }

  function galeria() {
    var g = $('.nv-pdp-gallery');
    if (!g) return;
    var DESK = '(min-width: 1025px)';
    var fav = $('.nv-pdp-fav[data-handle]');
    var handle = fav ? fav.getAttribute('data-handle') : (window.location.pathname.split('/').pop() || 'produto');
    var lb = null, fotos = [], atual = 0, voltaFoco = null;

    var kitUrl = null, kitPedido = null;
    function lista() {
      var out = [];
      $$('.nv-pdp-frame', g).forEach(function (f) {
        if (f.querySelector('.nv-p-kit')) {
          if (kitUrl) out.push(kitUrl);
          return;
        }
        var im = f.querySelector('img');
        if (!im) return;
        var src = semTamanho(im.currentSrc || im.src);
        if (out.indexOf(src) < 0) out.push(src);
      });
      return out;
    }
    function ext(u) {
      if (u.indexOf('blob:') === 0) return '.png';
      var m = (u.split('?')[0] || '').match(/\.(jpe?g|png|webp|gif)$/i);
      return m ? m[0].toLowerCase() : '.jpg';
    }
    function nome(i) { return handle + '-' + (i + 1) + ext(fotos[i]); }

    function monta() {
      lb = document.createElement('div');
      lb.className = 'nv-lb';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Galeria de imagens do produto');
      lb.hidden = true;
      lb.innerHTML =
        '<div class="nv-lb-top">' +
          '<span class="nv-lb-count" aria-live="polite"></span>' +
          '<div class="nv-lb-acts">' +
            '<button type="button" class="nv-lb-btn nv-lb-btn--white" data-lb-dl><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4v11"/><path d="m7.5 11 4.5 4.5 4.5-4.5"/><path d="M5 19h14"/></svg>Baixar imagem</button>' +
            '<button type="button" class="nv-lb-btn" data-lb-all><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4v11"/><path d="m7.5 11 4.5 4.5 4.5-4.5"/><path d="M5 19h14"/></svg><span>Baixar todas (.zip)</span></button>' +
            '<button type="button" class="nv-lb-x" data-lb-close aria-label="Fechar galeria"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
          '</div>' +
        '</div>' +
        '<div class="nv-lb-stage">' +
          '<button type="button" class="nv-lb-nav nv-lb-prev" data-lb-prev aria-label="Imagem anterior"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 6-6 6 6 6"/></svg></button>' +
          '<img class="nv-lb-img" alt="">' +
          '<button type="button" class="nv-lb-nav nv-lb-next" data-lb-next aria-label="Pr\u00f3xima imagem"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg></button>' +
        '</div>' +
        '<div class="nv-lb-thumbs" role="list"></div>';
      document.body.appendChild(lb);
      lb.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('[data-lb-close]') || t === lb.querySelector('.nv-lb-stage')) { fecha(); return; }
        if (t.closest('[data-lb-prev]')) { vai(atual - 1); return; }
        if (t.closest('[data-lb-next]')) { vai(atual + 1); return; }
        if (t.closest('[data-lb-dl]')) { baixar(fotos[atual], nome(atual)); return; }
        if (t.closest('[data-lb-all]')) {
          var bt = t.closest('[data-lb-all]');
          if (bt.classList.contains('nv-loading')) return;
          var rot = bt.querySelector('span');
          bt.classList.add('nv-loading');
          if (rot) rot.textContent = 'Preparando...';
          var fim = function () { bt.classList.remove('nv-loading'); if (rot) rot.textContent = 'Baixar todas (.zip)'; };
          baixarZip(fotos.slice(), fotos.map(function (u, i) { return nome(i); }), handle + '-imagens.zip').then(fim).catch(function () {
            fim();
            fotos.forEach(function (u, i) { setTimeout(function () { baixar(u, nome(i)); }, i * 450); });
          });
          return;
        }
        var th = t.closest('[data-lb-i]');
        if (th) vai(parseInt(th.getAttribute('data-lb-i'), 10));
      });
      document.addEventListener('keydown', function (e) {
        if (!lb || lb.hidden) return;
        if (e.key === 'Escape') fecha();
        else if (e.key === 'ArrowLeft') vai(atual - 1);
        else if (e.key === 'ArrowRight') vai(atual + 1);
        else if (e.key === 'Tab') {
          var foc = $$('button', lb);
          var i = foc.indexOf(document.activeElement);
          if (e.shiftKey && i <= 0) { e.preventDefault(); foc[foc.length - 1].focus(); }
          else if (!e.shiftKey && i === foc.length - 1) { e.preventDefault(); foc[0].focus(); }
        }
      });
    }
    function vai(i) {
      if (!fotos.length) return;
      atual = (i + fotos.length) % fotos.length;
      var img = lb.querySelector('.nv-lb-img');
      img.src = comLargura(fotos[atual], 2000);
      img.alt = 'Imagem ' + (atual + 1) + ' de ' + fotos.length;
      lb.querySelector('.nv-lb-count').textContent = (atual + 1) + ' / ' + fotos.length;
      $$('[data-lb-i]', lb).forEach(function (b, j) {
        b.classList.toggle('nv-on', j === atual);
        b.setAttribute('aria-current', j === atual ? 'true' : 'false');
        if (j === atual && b.scrollIntoView) b.scrollIntoView({ block: 'nearest', inline: 'center' });
      });
      var um = fotos.length < 2;
      lb.querySelector('[data-lb-prev]').hidden = um;
      lb.querySelector('[data-lb-next]').hidden = um;
      lb.querySelector('[data-lb-all]').hidden = um;
    }
    function abre(i) {
      var kf = $('.nv-pdp-frame .nv-p-kit', g);
      if (kf && !kitUrl) {
        if (!kitPedido) {
          kitPedido = kitImagem(kf.closest('.nv-pdp-frame'), 2000).then(function (u) {
            if (!u) return;
            kitUrl = u;
            if (lb && !lb.hidden) {
              var eraAtual = fotos[atual];
              abre(0);
              if (eraAtual) { var j = fotos.indexOf(eraAtual); if (j > 0) vai(j); }
            }
          });
        }
      }
      fotos = lista();
      if (!fotos.length) return;
      if (!lb) monta();
      var box = lb.querySelector('.nv-lb-thumbs');
      box.innerHTML = '';
      fotos.forEach(function (u, j) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nv-lb-th';
        b.setAttribute('data-lb-i', j);
        b.setAttribute('aria-label', 'Ver imagem ' + (j + 1));
        b.innerHTML = '<img src="' + comLargura(u, 200) + '" alt="" loading="lazy">';
        box.appendChild(b);
      });
      voltaFoco = document.activeElement;
      lb.hidden = false;
      document.documentElement.classList.add('nv-lb-open');
      vai(i);
      var x = lb.querySelector('[data-lb-close]');
      if (x) x.focus();
    }
    function fecha() {
      if (!lb) return;
      lb.hidden = true;
      document.documentElement.classList.remove('nv-lb-open');
      if (voltaFoco && voltaFoco.focus) voltaFoco.focus();
    }

    g.addEventListener('click', function (e) {
      if (!window.matchMedia(DESK).matches) return;
      var f = e.target.closest('.nv-pdp-frame');
      if (!f) return;
      if (f.querySelector('.nv-p-kit')) { abre(0); return; }
      var im = f.querySelector('img:not(.nv-kit-item)');
      var src = im ? semTamanho(im.currentSrc || im.src) : '';
      var idx = Math.max(0, lista().indexOf(src));
      abre(idx);
    });

    /* a foto montada do kit fica pronta logo depois que a pagina carrega */
    var kfPre = $('.nv-pdp-frame .nv-p-kit', g);
    if (kfPre) {
      window.addEventListener('load', function () {
        setTimeout(function () {
          if (kitPedido || kitUrl || !window.matchMedia(DESK).matches) return;
          kitPedido = kitImagem(kfPre.closest('.nv-pdp-frame'), 2000).then(function (u) {
            if (!u) return;
            kitUrl = u;
            if (lb && !lb.hidden) abre(0);
          });
        }, 1200);
      });
    }
  }

  /* ---------- perguntas e respostas do app vao para o box "Ficou com alguma duvida?" ---------- */
  function folha(root, re) {
    return $$('*', root).filter(function (el) {
      return el.children.length === 0 && re.test((el.textContent || '').trim());
    })[0] || null;
  }
  function moverQA(widget) {
    var slot = $('[data-nv-qa-slot]');
    if (!slot || !widget) return;
    var head = folha(widget, /^perguntas\s*(&|e|&amp;)\s*respostas/i);
    if (!head) return;
    var revHead = folha(widget, /^avalia(\u00e7|c)(\u00f5|o)es$/i);
    var node = head;
    while (node.parentElement && node.parentElement !== widget && !(revHead && node.parentElement.contains(revHead))) node = node.parentElement;
    if (revHead && node.contains(revHead)) return;
    head.classList.add('nv-qa-orig-h');
    slot.appendChild(node);
    var askOrig = porTexto(node, 'button, a, [role="button"]', /fazer (uma )?pergunta|^perguntar/i);
    if (askOrig) askOrig.classList.add('nv-qa-ask-orig');
    slot.hidden = false;
    var side = $('[data-nv-conversa-side]');
    if (side) side.hidden = false;
    var grid = $('[data-nv-conversa-grid]');
    if (grid) grid.classList.add('nv-has-faq');
  }

  /* ---------- ultimas unidades por variante ---------- */
  function estoque(box) {
    var map = {};
    try { map = JSON.parse($('[data-nv-estoque]', box).textContent); } catch (e) { return; }
    var selo = $('[data-nv-poucas]', box);
    var txt = $('[data-nv-poucas-txt]', box);
    if (!selo) return;
    var limite = parseInt(box.getAttribute('data-limite'), 10) || 10;
    var mostraQtd = box.getAttribute('data-qtd') === '1';
    var form = $('.productView-details form[action*="/cart/add"]') || $('form[action*="/cart/add"]');
    var input = form ? form.querySelector('[name="id"]') : null;
    if (!input) return;
    var last = input.value;
    function upd() {
      if (input.value === last) return;
      last = input.value;
      var q = map[last];
      var on = typeof q === 'number' && q > 0 && q <= limite;
      selo.hidden = !on;
      if (on && txt) txt.textContent = !mostraQtd ? '\u00daltimas unidades' : (q === 1 ? '\u00daltima unidade' : '\u00daltimas ' + q + ' unidades');
    }
    document.addEventListener('change', function () { setTimeout(upd, 60); });
    document.addEventListener('click', function () { setTimeout(upd, 120); });
  }

  /* ---------- avaliacoes ---------- */
  function reviews(sec) {
    var widget = $('.konfidency-reviews-details', sec);
    var strip = $('[data-nv-rv-strip]', sec);
    var row = $('[data-nv-rv-row]', sec);
    var count = $('[data-nv-rv-count]', sec);
    if (!widget || !row) return;
    var reordenar = sec.getAttribute('data-reordenar') === '1';
    var escolhaCliente = false;
    var assinatura = '';

    widget.addEventListener('change', function (e) {
      if (e.target && e.target.tagName === 'SELECT') escolhaCliente = true;
    });

    function ehMidia(el) {
      if (el.tagName === 'VIDEO') return true;
      var r = el.getBoundingClientRect();
      if (r.width && r.width < 40) return false;
      var cls = ((el.className && el.className.baseVal !== undefined ? el.className.baseVal : el.className) || '') + ' ' + (el.alt || '');
      if (/avatar|star|estrela|logo|icon|verified|flag/i.test(cls)) return false;
      var src = el.currentSrc || el.src || '';
      if (!src || /\.svg(\?|$)/i.test(src) || src.indexOf('data:') === 0) return false;
      return true;
    }

    /* sobe da midia ate o card da avaliacao: o ancestral que tem irmaos iguais a ele */
    function cardDe(el) {
      var node = el;
      while (node && node.parentElement && node.parentElement !== widget) {
        var pai = node.parentElement;
        var cls = node.className;
        if (typeof cls === 'string' && cls.trim()) {
          var iguais = 0;
          for (var i = 0; i < pai.children.length; i++) {
            var s = pai.children[i];
            if (s.tagName === node.tagName && s.className === cls) iguais++;
          }
          if (iguais >= 3 && (node.textContent || '').trim().length > 20) return node;
        }
        node = pai;
      }
      return null;
    }

    function run() {
      var midias = $$('img, video', widget).filter(ehMidia);
      var sig = midias.length + ':' + midias.map(function (m) { return m.currentSrc || m.src || ''; }).join('|').length;
      var cards = [];
      var porCard = [];
      midias.forEach(function (m) {
        var c = cardDe(m);
        if (!c) return;
        var idx = cards.indexOf(c);
        if (idx < 0) { cards.push(c); porCard.push([m]); } else porCard[idx].push(m);
      });

      /* avaliacoes com midia primeiro (respeita se a cliente escolheu outra ordem) */
      if (reordenar && !escolhaCliente && cards.length) {
        cards.forEach(function (c) { c.classList.add('nv-rv-media'); });
        var lista = cards[0].parentElement;
        var irmaos = $$(':scope > *', lista).filter(function (x) { return x.tagName === cards[0].tagName && x.className === cards[0].className; });
        var primeiroSem = null;
        for (var i = 0; i < irmaos.length; i++) { if (cards.indexOf(irmaos[i]) < 0) { primeiroSem = irmaos[i]; break; } }
        if (primeiroSem) {
          cards.forEach(function (c) {
            if (c.parentElement === lista && (primeiroSem.compareDocumentPosition(c) & Node.DOCUMENT_POSITION_FOLLOWING)) {
              lista.insertBefore(c, primeiroSem);
            }
          });
        }
      }

      if (sig === assinatura) return;
      assinatura = sig;

      /* faixa de fotos e videos */
      row.innerHTML = '';
      var n = 0;
      cards.forEach(function (c, ci) {
        porCard[ci].forEach(function (m) {
          if (n >= 24) return;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'nv-pdp-rvthumb';
          b.setAttribute('aria-label', m.tagName === 'VIDEO' ? 'Ver v\u00eddeo da avalia\u00e7\u00e3o' : 'Ver foto da avalia\u00e7\u00e3o');
          if (m.tagName === 'VIDEO') {
            var poster = m.getAttribute('poster');
            var src = m.currentSrc || m.src || (m.querySelector('source') ? m.querySelector('source').src : '');
            if (poster) {
              var ip = document.createElement('img'); ip.src = poster; ip.alt = ''; ip.loading = 'lazy'; b.appendChild(ip);
            } else if (src) {
              var v = document.createElement('video'); v.src = src + (src.indexOf('#') < 0 ? '#t=0.5' : ''); v.muted = true; v.playsInline = true; v.preload = 'metadata'; b.appendChild(v);
            }
            var pl = document.createElement('span');
            pl.className = 'nv-pdp-rvthumb-play';
            pl.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5z"/></svg>';
            b.appendChild(pl);
          } else {
            var im = document.createElement('img'); im.src = m.currentSrc || m.src; im.alt = ''; im.loading = 'lazy'; b.appendChild(im);
          }
          b.addEventListener('click', function () {
            go(c);
            c.classList.add('nv-rv-hl');
            setTimeout(function () { c.classList.remove('nv-rv-hl'); }, 2200);
            setTimeout(function () { try { m.click(); } catch (e) {} }, 650);
          });
          row.appendChild(b);
          n++;
        });
      });
      strip.hidden = n === 0;
      if (count) count.textContent = cards.length ? cards.length + (cards.length === 1 ? ' avalia\u00e7\u00e3o' : ' avalia\u00e7\u00f5es') + ' com m\u00eddia' : '';
    }

    var t = null;
    function agenda() { clearTimeout(t); t = setTimeout(function () { run(); moverQA(widget); }, 450); }
    if ('MutationObserver' in window) new MutationObserver(agenda).observe(widget, { childList: true, subtree: true });
    window.addEventListener('load', agenda);
    agenda();
  }

  /* ---------- converse conosco ---------- */
  function porTexto(root, sel, re) {
    if (!root) return null;
    var l = $$(sel, root).filter(function (el) { return re.test((el.textContent || '').trim()); });
    return l[0] || null;
  }
  function conversa() {
    var widget = $('#nv-avaliacoes .konfidency-reviews-details') || $('.konfidency-reviews-details');
    var alvo = $('#nv-avaliacoes');
    $$('[data-nv-ask]').forEach(function (b) {
      b.addEventListener('click', function () {
        var slot = $('[data-nv-qa-slot]');
        var btn = porTexto(slot, 'button, a, [role="button"]', /fazer (uma )?pergunta|^perguntar/i) || porTexto(widget, 'button, a, [role="button"]', /fazer (uma )?pergunta|^perguntar/i);
        if (btn) { btn.click(); setTimeout(function () { go(slot && !slot.hidden ? slot : alvo); }, 250); } else go(alvo);
      });
    });
    $$('[data-nv-qa]').forEach(function (b) {
      b.addEventListener('click', function () {
        var h = null;
        if (widget) {
          h = $$('h1, h2, h3, h4, h5, div, span, p', widget).filter(function (el) {
            return el.children.length === 0 && /^perguntas/i.test((el.textContent || '').trim());
          })[0];
        }
        go(h || alvo);
      });
    });
  }

  /* ---------- nota do produto leva as avaliacoes ---------- */
  function nota() {
    var alvo = $('#nv-avaliacoes');
    if (!alvo) return;
    $$('.productView-details .konfidency-reviews-summary, .halo-productView-right .konfidency-reviews-summary').forEach(function (el) {
      el.style.cursor = 'pointer';
      el.addEventListener('click', function (e) { e.preventDefault(); go(alvo); });
    });
  }

  /* ---------- favoritar com coracoes (mesma lista de desejos do site) ---------- */
  function favLista() {
    if (window.NV && NV.wishlistGet) return NV.wishlistGet();
    try { return JSON.parse(localStorage.getItem('wishlistItem')) || []; } catch (e) { return []; }
  }
  function favSalva(handle, on) {
    if (window.NV && NV.wishlistSet) { NV.wishlistSet(handle, on); return; }
    var l = favLista(); var i = l.indexOf(handle);
    if (on && i < 0) l.push(handle);
    if (!on && i > -1) l.splice(i, 1);
    try { localStorage.setItem('wishlistItem', JSON.stringify(l)); } catch (e) {}
  }
  function coracoes(btn) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    btn.classList.remove('nv-pop'); void btn.offsetWidth; btn.classList.add('nv-pop');
    var path = 'M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.5A4 4 0 0 1 19 10c0 5.5-7 10-7 10Z';
    for (var k = 0; k < 6; k++) {
      var h = document.createElement('span');
      h.className = 'nv-pdp-heart';
      h.setAttribute('aria-hidden', 'true');
      h.innerHTML = '<svg viewBox="0 0 24 24"><path d="' + path + '"/></svg>';
      h.style.setProperty('--dx', (Math.round(Math.random() * 36) - 18) + 'px');
      h.style.setProperty('--sc', (0.6 + Math.random() * 0.6).toFixed(2));
      h.style.animationDelay = (k * 70) + 'ms';
      btn.appendChild(h);
      setTimeout(function (el) { return function () { if (el.parentNode) el.parentNode.removeChild(el); }; }(h), 1400);
    }
  }
  function favoritar() {
    $$('.nv-pdp-fav[data-handle]').forEach(function (b) {
      var on = favLista().indexOf(b.dataset.handle) > -1;
      b.classList.toggle('nv-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var novo = !b.classList.contains('nv-on');
        b.classList.toggle('nv-on', novo);
        b.setAttribute('aria-pressed', novo ? 'true' : 'false');
        var t = b.querySelector('span');
        if (t) t.textContent = novo ? 'Favoritado' : 'Favoritar';
        favSalva(b.dataset.handle, novo);
        if (novo) coracoes(b);
        if (window.NV && NV.toast) NV.toast(novo ? 'Adicionado aos favoritos' : 'Removido dos favoritos');
      });
      if (on) { var t0 = b.querySelector('span'); if (t0) t0.textContent = 'Favoritado'; }
    });
  }

  /* ---------- comprar agora: adiciona e vai direto para o pagamento ---------- */
  function comprarAgora() {
    $$('[data-nv-buynow]').forEach(function (b) {
      b.addEventListener('click', function () {
        var form = $('.productView-details form[action*="/cart/add"]') || $('form[action*="/cart/add"]');
        if (!form) return;
        b.classList.add('nv-loading');
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
          body: new FormData(form)
        }).then(function (r) {
          if (!r.ok) throw new Error('add');
          window.location.href = '/checkout';
        }).catch(function () {
          b.classList.remove('nv-loading');
          var s = form.querySelector('[type="submit"], .product-form__submit');
          if (s) s.click();
        });
      });
    });
  }

  /* ---------- preco: valor atual maior e flag com a porcentagem de desconto ---------- */
  function valor(t) {
    var m = (t || '').replace(/\s/g, '').match(/(\d{1,3}(\.\d{3})*|\d+),(\d{2})/);
    return m ? parseFloat(m[0].replace(/\./g, '').replace(',', '.')) : 0;
  }
  function desconto() {
    var box = $('.productView-top.nv-pdp-on .halo-productView-right .productView-price');
    if (!box) return;
    var ocupado = false;
    function run() {
      if (ocupado) return;
      ocupado = true;
      var velho = $('.nv-pdp-off', box);
      if (velho) velho.parentNode.removeChild(velho);
      $$('.nv-pdp-now, .nv-pdp-cmp', box).forEach(function (el) { el.classList.remove('nv-pdp-now', 'nv-pdp-cmp'); });
      var itens = $$('span, s, del', box).filter(function (el) {
        return el.offsetParent !== null && !el.querySelector('span, s, del') && valor(el.textContent) > 0;
      });
      if (itens.length) {
        var max = itens[0], min = itens[0];
        itens.forEach(function (el) {
          if (valor(el.textContent) > valor(max.textContent)) max = el;
          if (valor(el.textContent) < valor(min.textContent)) min = el;
        });
        min.classList.add('nv-pdp-now');
        var a = valor(max.textContent), n = valor(min.textContent);
        if (a > n) {
          max.classList.add('nv-pdp-cmp');
          var pct = Math.round((1 - n / a) * 100);
          if (pct > 0) {
            var f = document.createElement('span');
            f.className = 'nv-pdp-off';
            f.textContent = '-' + pct + '%';
            /* linha 1: preco riscado + flag; linha 2: preco atual */
            max.parentNode.insertBefore(f, max.nextSibling);
            f.parentNode.insertBefore(min, f.nextSibling);
          }
        }
      }
      setTimeout(function () { ocupado = false; }, 50);
    }
    run();
    if ('MutationObserver' in window) {
      var t = null;
      new MutationObserver(function () { if (ocupado) return; clearTimeout(t); t = setTimeout(run, 120); }).observe(box, { childList: true, subtree: true, characterData: true });
    }
  }

  /* ---------- desktop: coluna do meio gira sozinha + miniaturas embaixo das fotos ---------- */
  function autoGaleria() {
    var g = $('.nv-pdp-gallery');
    if (!g) return;
    var rest = $('.nv-pdp-rest', g);
    if (!rest) return;
    var fr = $$('.nv-pdp-frame', rest).filter(function (f) { return f.parentElement === rest; });
    if (fr.length < 2) return;
    var DESK = window.matchMedia('(min-width: 1025px)');
    var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    g.classList.add('nv-pdp-auto');

    var bar = document.createElement('div');
    bar.className = 'nv-pdp-thumbs';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Fotos do produto');
    fr.forEach(function (f, i) {
      var im = f.querySelector('img');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nv-pdp-thumb-b';
      b.setAttribute('aria-label', 'Ver foto ' + (i + 2));
      if (im) b.innerHTML = '<img src="' + comLargura(semTamanho(im.currentSrc || im.src), 200) + '" alt="" loading="lazy">';
      b.addEventListener('click', function () { ir(i); reinicia(); });
      bar.appendChild(b);
    });
    var track = $('.nv-pdp-track', g);
    (track || g).appendChild(bar);

    var atual = 0, timer = null, pausa = false;
    function ir(i) {
      atual = (i + fr.length) % fr.length;
      if (DESK.matches) rest.scrollTo({ left: fr[atual].offsetLeft - fr[0].offsetLeft, behavior: reduz ? 'auto' : 'smooth' });
      $$('.nv-pdp-thumb-b', bar).forEach(function (b, j) {
        b.classList.toggle('nv-on', j === atual);
        b.setAttribute('aria-current', j === atual ? 'true' : 'false');
      });
    }
    function tick() { if (!pausa && DESK.matches && !document.hidden) ir(atual + 1); }
    function reinicia() { clearInterval(timer); if (!reduz) timer = setInterval(tick, 2500); }
    g.addEventListener('mouseenter', function () { pausa = true; });
    g.addEventListener('mouseleave', function () { pausa = false; });
    g.addEventListener('focusin', function () { pausa = true; });
    g.addEventListener('focusout', function () { pausa = false; });
    window.addEventListener('resize', function () { ir(atual); });
    ir(0);
    reinicia();
  }

  function start() {
    autoGaleria();
    $$('[data-nv-kitcar-row]').forEach(function (row) {
      var nav = $('.nv-pdp-kitnav', row.closest('.nv-pdp-kit'));
      function chk() { if (nav) nav.hidden = row.scrollWidth <= row.clientWidth + 4; }
      chk();
      window.addEventListener('resize', chk);
      window.addEventListener('load', chk);
    });
    $$('[data-nv-kitcar]').forEach(function (b) {
      b.addEventListener('click', function () {
        var sec = b.closest('.nv-pdp-kit');
        var row = sec ? $('[data-nv-kitcar-row]', sec) : null;
        if (!row) return;
        var card = $('.nv-pdp-kitcard', row);
        var passo = card ? card.getBoundingClientRect().width + 30 : 250;
        row.scrollBy({ left: passo * parseInt(b.getAttribute('data-nv-kitcar'), 10), behavior: 'smooth' });
      });
    });
    $$('[data-nv-tabs]').forEach(tabs);
    $$('[data-nv-filtros]').forEach(filtros);
    galeria();
    $$('[data-nv-clamp]').forEach(clamp);
    $$('[data-nv-selos]').forEach(estoque);
    $$('[data-nv-reviews]').forEach(reviews);
    conversa();
    nota();
    favoritar();
    comprarAgora();
    desconto();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
